import { useQuery } from '@tanstack/react-query';

import { fetchDivisionList } from '../../data-provider/select-options';

export const useGetDivisionList = () => {
  return useQuery({
    queryFn: () => fetchDivisionList(),
    queryKey: ['claims-loss-and-damage-division-list'],
    staleTime: Number.POSITIVE_INFINITY,
  });
};
